var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DemoStep",
    [
      _c(
        "form",
        { staticClass: "persona-grid" },
        _vm._l(_vm.personaIds, function (persona) {
          return _c(
            "label",
            {
              key: persona,
              staticClass: "persona-card pa-4 d-flex gap-2 items-start",
              class: {
                "active-card": _vm.selected === persona,
              },
              attrs: { "aria-labelledby": `persona-title-${persona}` },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selected,
                    expression: "selected",
                  },
                ],
                attrs: {
                  type: "radio",
                  name: "botPersona",
                  id: `input-${persona}`,
                },
                domProps: {
                  value: persona,
                  checked: _vm._q(_vm.selected, persona),
                },
                on: {
                  change: function ($event) {
                    _vm.selected = persona
                  },
                },
              }),
              _c("img", {
                staticClass: "persona-avatar flex-shrink-0",
                attrs: {
                  src: _vm.$t(`demo.personas.${persona}.avatar`),
                  alt: `Illustration of ${_vm.$t(
                    `demo.personas.${persona}.name`
                  )}`,
                },
              }),
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "h3",
                  {
                    staticClass: "text-h4 primary--text",
                    attrs: { id: `persona-title-${persona}` },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t(`demo.personas.${persona}.name`)) +
                        " "
                    ),
                  ]
                ),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t(`demo.personas.${persona}.description`))
                  ),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _c("DemoBtns", {
        on: { onBack: _vm.previousStep, onNext: _vm.nextStep },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }